// Website closure notice on a restaurant card (data-closure-start, -end and
// -status, from OpenTouristInfo via EliSync): while the closure runs, the card
// is closed whatever its weekly hours say. Dates are site-local YYYY-MM-DD.
const isoDatePattern = /^\d{4}-\d{2}-\d{2}$/;

// The status text to show next to "Geschlossen", or null when no closure runs today.
export function getActiveClosureStatus(dataset, today) {
  const start = (dataset && dataset.closureStart) || "";
  const end = (dataset && dataset.closureEnd) || "";

  if (
    !isoDatePattern.test(start) ||
    !isoDatePattern.test(end) ||
    !isoDatePattern.test(today || "") ||
    today < start ||
    today > end
  ) {
    return null;
  }

  return String(dataset.closureStatus || "").trim();
}
